import Onboarding from "../../components/onboarding";
import { useNavigate } from "react-router-dom";

const Instructions = () => {
  const navigate = useNavigate();
  return (
    <Onboarding
      typePage
      setHideOnboarding={() => {}}
      callBack={() => navigate("/planejadora")}
    />
  );
};

export default Instructions;
